export enum ColumnId {
    PERFORMER = 'performer',
    MI2_SCORE = 'mi2_score',
    IMPROVEMENT_CATEGORY = 'improvement_category',
    OA_SCORE = 'oa_score',
    MI2_PLUS_SCORE = 'mi2_plus_score',
    SCORECARD_POINTS = 'scorecard_points',
    SCORECARD_PERFORMANCE_CLASS = 'scorecard_performance_class',
    PREVIOUS_SCORECARD_POINTS = 'previous_scorecard_points',
    PREVIOUS_SCORECARD_PERFORMANCE_CLASS = 'previous_scorecard_performance_class',
    IMPROVEMENT_ACHIEVED = 'improvement_achieved',
    MOVEMENT_OF_RANKING = 'movement_of_ranking',
}
